import { useState, useEffect, useCallback } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import DashboardPanelSwitcher from "../Common/DashboardPanelSwitcher";
import { performAppLogout } from "../../utils/authLogout";
import "./FridayDashboard.css";

const NAV_ITEMS = [
  { to: "/dashboard", label: "Sales & Marketing", end: true },
  { to: "/dashboard/sales", label: "Sales" },
  { to: "/dashboard/brand", label: "Brand" },
  { to: "/dashboard/diagnosis", label: "Diagnosis" },
  { to: "/dashboard/division-performance", label: "Division Performance" },
  { to: "/dashboard/sfe", label: "Sales Force Effectiveness" },
  { to: "/dashboard/efforts", label: "Efforts" },
  { to: "/dashboard/field-sales", label: "Field Sales" },
  { to: "/dashboard/executive-focus-note", label: "Executive Focus Note" },
  { to: "/dashboard/semantic-query", label: "Semantic Query" },
  { to: "/chat", label: "Chat" },
];

export default function FridayDashboardLayout() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const isDivisionPerformance =
    location.pathname.includes("/division-performance") ||
    location.pathname.includes("/sfe") ||
    location.pathname.includes("/efforts") ||
    location.pathname.includes("/field-sales");

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  // Close sidebar on Escape key
  useEffect(() => {
    function handleKey(e) {
      if (e.key === "Escape") setSidebarOpen(false);
    }
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, []);

  const toggleSidebar = useCallback(() => setSidebarOpen((v) => !v), []);

  return (
    <div className="friday-dashboard-shell">
      {/* Mobile overlay backdrop */}
      {sidebarOpen && (
        <div
          className="friday-sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`friday-dashboard-sidebar ${sidebarOpen ? "friday-dashboard-sidebar--open" : ""}`}
        aria-label="Dashboard navigation"
      >
        <div className="friday-dashboard-logo">
          Emcure
          <span>Sales & Marketing</span>
        </div>

        <nav className="friday-dashboard-nav">
          {NAV_ITEMS.map(({ to, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `friday-dashboard-link${isActive ? " active" : ""}`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="friday-dashboard-sidebar-footer">
          <DashboardPanelSwitcher />
          <button
            type="button"
            className="friday-dashboard-logout-btn"
            onClick={() => performAppLogout()}
            title="Logout"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            Logout
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main
        className={`friday-dashboard-main${isDivisionPerformance ? " friday-dashboard-main--division-performance" : ""}`}
      >
        {/* Mobile hamburger header */}
        <div className="friday-mobile-header">
          <button
            className="friday-hamburger"
            onClick={toggleSidebar}
            aria-label="Toggle navigation"
          >
            <span />
            <span />
            <span />
          </button>
          <div className="friday-mobile-title">Emcure</div>
        </div>

        <Outlet />
      </main>
    </div>
  );
}
